import React from 'react';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { useLaborProductivityDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/store/laborProductivityDashboard.store';
import {
  CALLOUT_TYPE_COLORS,
  EMPLOYMENT_TYPE_LABELS,
  DONUT_CHART_SIZE,
  DONUT_INNER_RATIO,
} from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/LaborProductivityDashboard.constants';
import {
  DonutChart,
  DonutChartItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/DonutChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/LaborProductivityDashboard.styled';
import {
  ChartContainer,
  LegendContainer,
  LegendItem,
  LegendDot,
  LegendLabel,
  LegendValue,
} from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/CalloutShiftsByTypeChart.styled';

function getTypeColor(type: string, index: number, fallbackColors: string[]): string {
  return CALLOUT_TYPE_COLORS[type] || fallbackColors[index % fallbackColors.length];
}

export const CalloutShiftsByTypeChart: React.FC = () => {
  const data = useLaborProductivityDashboardStore((s) => s.calloutShiftsByType);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available for the selected filters.</EmptyStateContainer>;
  }

  const items: DonutChartItem[] = data.map((d, i) => {
    const label = EMPLOYMENT_TYPE_LABELS[d.type] ?? d.type;
    return {
      label,
      value: d.count,
      color: getTypeColor(d.type, i, palette.chartColors),
      ariaLabel: `${label}: ${d.count} shifts (${d.percentage}%)`,
      tooltipHtml: `<strong>${label}</strong><br/>Call Out Shifts: ${d.count}<br/>Share: ${d.percentage}%`,
    };
  });

  return (
    <ChartContainer>
      <DonutChart items={items} size={DONUT_CHART_SIZE} innerRadiusRatio={DONUT_INNER_RATIO} />
      <LegendContainer>
        {data.map((d, i) => (
          <LegendItem key={d.type}>
            <LegendDot $color={getTypeColor(d.type, i, palette.chartColors)} />
            <LegendLabel>{EMPLOYMENT_TYPE_LABELS[d.type] ?? d.type}</LegendLabel>
            <LegendValue>
              {d.count} ({d.percentage}%)
            </LegendValue>
          </LegendItem>
        ))}
      </LegendContainer>
    </ChartContainer>
  );
};
